import { render, staticRenderFns } from "./missed-call-handler-settings.vue?vue&type=template&id=4a8580d3&scoped=true"
import script from "./missed-call-handler-settings.vue?vue&type=script&lang=js"
export * from "./missed-call-handler-settings.vue?vue&type=script&lang=js"
import style0 from "./missed-call-handler-settings.vue?vue&type=style&index=0&id=4a8580d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8580d3",
  null
  
)

export default component.exports